import { getConnectAccountInfo } from 'api/prospect';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { isOpPortal } from 'utils/common';

export interface IConnectAccountInfoResponse {
    id: number;
    providerId: number;
    stripeConnectAccountId: string;
    accountStatus: string;
    detailsSubmitted: boolean;
    companyOwnerPersonId: string;
    companyRepresentativePersonId: string;
    chargesEnabled: boolean;
    payoutsEnabled: boolean;
    createAt: string;
    createBy: number;
    updateAt: string;
    updateBy: number;
}

export const useGetConnectAccountInfo: () => [
    IConnectAccountInfoResponse | undefined,
    boolean,
    () => Promise<void>,
] = () => {
    const [data, setData] = useState<IConnectAccountInfoResponse>();
    const [loading, setLoading] = useState(false);

    const fetch = async () => {
        const isOps = isOpPortal();
        if (isOps) {
            return;
        }
        setLoading(true);
        try {
            const res = await getConnectAccountInfo();
            if (res && !res.error) {
                setData(res?.data?.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetch();
    }, []);

    return [data, loading, fetch];
};
